import { useBlock, useSlate } from '@tribeplatform/react-slate-kit/hooks'
import {
  BlockType,
  BlockWrapperComponent,
} from '@tribeplatform/react-slate-kit/types'

import { BlockWrapper } from './BlockWrapper'
import { LayoutWrapper } from './LayoutWrapper'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const Wrapper: BlockWrapperComponent = ({ children, ...props }) => {
  const { mode } = useSlate()
  const {
    block: {
      config: { type },
    },
  } = useBlock()

  if (mode === 'live') {
    return children
  }

  if (type === BlockType.Layout) {
    return <LayoutWrapper {...props}>{children}</LayoutWrapper>
  }

  return <BlockWrapper {...props}>{children}</BlockWrapper>
}
